import { render, staticRenderFns } from "./AnnotationsContainer.vue?vue&type=template&id=61037ef9&scoped=true"
import script from "./AnnotationsContainer.vue?vue&type=script&lang=js"
export * from "./AnnotationsContainer.vue?vue&type=script&lang=js"
import style0 from "./AnnotationsContainer.vue?vue&type=style&index=0&id=61037ef9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61037ef9",
  null
  
)

export default component.exports